<template>
  <div v-if="hasAnything" class="details">
    <div v-if="modeLabel" class="detailRow">
      <span class="detailLabel">MODE</span>
      <span class="detailValue">{{ modeLabel }}</span>
    </div>
    <div v-if="missingDataLabel" class="detailRow">
      <span class="detailLabel">NO DATA</span>
      <span class="detailValue">{{ missingDataLabel }}</span>
    </div>
    <div v-for="field in visibleFields" :key="field.key" class="detailRow">
      <span class="detailLabel">{{ field.label }}</span>
      <span class="detailValue">{{ field.value }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  config: Record<string, any>
}>()

const fieldDefs = [
  { key: 'industry', label: 'INDUSTRY' },
  { key: 'geography', label: 'GEOGRAPHY' },
  { key: 'funding_stage', label: 'FUNDING' },
  { key: 'revenue', label: 'REVENUE' },
  { key: 'company_size', label: 'SIZE' },
]

const visibleFields = computed(() =>
  fieldDefs
    .filter((f) => (props.config.icp?.[f.key] || '').trim())
    .map((f) => ({ ...f, value: props.config.icp[f.key] }))
)

const modeLabel = computed(() => {
  const mode = props.config.mode
  if (mode === 'drop_matching') return 'Exclude matching'
  return 'Keep matching'
})

const missingDataLabel = computed(() => {
  if (props.config.fail_on_missing_data === false) return 'Keep (pass through)'
  return 'Exclude'
})

const hasAnything = computed(() => true)
</script>

<style scoped>
.details {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}
.detailRow {
  display: flex;
  align-items: baseline;
  gap: var(--space-3);
}
.detailLabel {
  font-family: var(--font-sans);
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--tracking-wide);
  color: var(--color-text-tertiary);
  flex-shrink: 0;
  min-width: 70px;
}
.detailValue {
  font-family: var(--font-sans);
  font-size: var(--fs-sm);
  color: var(--color-text-secondary);
}
</style>
